import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'
import { useModals, useNumericParams, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateOrEditTaskListSectionModal from '@modals/CreateOrEditTaskListSectionModal'
import CreateOrEditTaskListItemModal from '@modals/CreateOrEditTaskListItemModal'

import PageContent from './components/PageContent'

export type PageContextPayload = {
  callbacks: {
    showCreateOrEditTaskListSectionModal: (payload: any) => void,
    showCreateOrEditTaskListItemModal: (payload: any) => void,
  },
}

// @ts-expect-error TS7006
const callbacks = (component: string, setState) => {
  const componentCallbacks = {
    CreateOrEditTaskListSectionModal: {
      closeModal: () => setState({ showCreateOrEditTaskListSectionModal: false }),
      createTaskListSection: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateTaskListSection: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    CreateOrEditTaskListItemModal: {
      closeModal: () => setState({ showCreateOrEditTaskListItemModal: false }),
      createTaskListItem: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      deleteTaskListItem: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
      updateTaskListItem: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  // @ts-expect-error TS7053
  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateOrEditTaskListSectionModal: false,
  showCreateOrEditTaskListItemModal: false,
}

const TasksList = () => {
  const { taskListId } = useNumericParams()

  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditTaskListSectionModal, showCreateOrEditTaskListItemModal } = state

  const modalContext = useModals()
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showCreateOrEditTaskListSectionModal: (payload: any) => {
        setModalData('CreateOrEditTaskListSectionModal', payload)
        setState({ showCreateOrEditTaskListSectionModal: true })
      },
      showCreateOrEditTaskListItemModal: (payload: any) => {
        setModalData('CreateOrEditTaskListItemModal', payload)
        setState({ showCreateOrEditTaskListItemModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent taskListId={taskListId} />

        <CreateOrEditTaskListSectionModal
          callbacks={callbacks('CreateOrEditTaskListSectionModal', setState)}
          requestOptions={{
            include_related_entity_subject: true,
            include_task_list_item_related_entities: true,
            include_task_list_section_items: true,
          }}
          showModal={showCreateOrEditTaskListSectionModal}
        />

        <CreateOrEditTaskListItemModal
          callbacks={callbacks('CreateOrEditTaskListItemModal', setState)}
          showModal={showCreateOrEditTaskListItemModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default TasksList
